import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { Chip } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import useStyles from './styles';
// import { getInstanceRunningStatus } from '../../redux/Actions/clientInfo.action';

export default function InstanceName() {
    const classes = useStyles();
    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);
    return (
        <>
            <Typography variant="h1" className={classes.instanceName}>
                {clientInfo.name}
                <Chip
                    icon={<FiberManualRecordIcon className={classes.instanceStatusChip} />}
                    label={clientInfo.status ? clientInfo.status.toUpperCase() : ''}
                    className={classes.instanceStatus}
                />
            </Typography>
        </>
    );
}
